document.documentElement.classList.remove('no-js');


// SEO/accessibility fallback: ensure storefront/app-rendered images always expose an alt attribute.
// Existing descriptive alt text is preserved. Only missing/blank values are filled.
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('img').forEach((img) => {
    if (!img.hasAttribute('alt') || !img.getAttribute('alt').trim()) {
      const card = img.closest('a, article, .product-card, .collection-card, section');
      const label = card && card.querySelector('h1, h2, h3, [aria-label]');
      const contextual = label ? (label.textContent || label.getAttribute('aria-label') || '').trim() : '';
      img.setAttribute('alt', contextual || 'NorthStar Society Co.');
    }
  });
});

const SOCIETY_NEWSLETTER_API = 'https://northstar-society-co-api.curly-dust-3326.workers.dev/api/newsletter-signup';

document.querySelectorAll('[data-society-newsletter-form]').forEach((form) => {
  form.addEventListener('submit', () => {
    const firstName = form.querySelector('[data-society-first-name]')?.value.trim() || '';
    const lastName = form.querySelector('[data-society-last-name]')?.value.trim() || '';
    const email = form.querySelector('[data-society-email]')?.value.trim() || '';
    const submitButton = form.querySelector('[data-society-submit]');

    if (!email) return;

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Connecting…';
    }

    // Send a parallel marketing copy to Brevo without taking over Shopify's
    // native customer-form submission. keepalive lets this request finish
    // while Shopify navigates to its normal form response.
    fetch(SOCIETY_NEWSLETTER_API, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ firstName, lastName, email }),
      keepalive: true
    }).catch((error) => {
      console.error('Brevo newsletter signup error:', error);
    });

    // No preventDefault(): Shopify still receives its native customer form.
  });
});
